module.exports = __webpack_public_path__ + "img/form-icon-email.397abd06.svg";